export const REQUEST_EXECUTION_STAMP_LOADING = 'REQUEST_EXECUTION_STAMP_LOADING';

export const REQUEST_EXECUTION_STAMP_ERROR = 'REQUEST_EXECUTION_STAMP_ERROR';

export const INITIATE_REQUEST_EXECUTION_STAMP_APPLICATION_SUCCESS =
  'INITIATE_REQUEST_EXECUTION_STAMP_APPLICATION_SUCCESS';

export const CLEAR_REQUEST_EXECUTION_STAMP_APPLICATION_ERROR = 'CLEAR_REQUEST_EXECUTION_STAMP_APPLICATION_ERROR';

export const FETCH_APPLICATION_REQUEST_EXECUTION_STAMP_SUCCESS = 'FETCH_APPLICATION_REQUEST_EXECUTION_STAMP_SUCCESS';

export const FETCH_DOCUMENTS_REQUEST_EXECUTION_STAMP_SUCCESS = 'FETCH_DOCUMENTS_REQUEST_EXECUTION_STAMP_SUCCESS';

export const REQUEST_EXECUTION_STAMP_CLEAR_DATA = 'REQUEST_EXECUTION_STAMP_CLEAR_DATA';

export const DOWNLOAD_DOCUMENT_REQUEST_EXECUTION_STAMP_SUCCESS = 'DOWNLOAD_DOCUMENT_REQUEST_EXECUTION_STAMP_SUCCESS';

export const REQUEST_EXECUTION_STAMP_CANCEL_APPLICATION_SUCCESS = 'REQUEST_EXECUTION_STAMP_CANCEL_APPLICATION_SUCCESS';

export const GET_MULTIPLE_PROPERTIES = 'GET_MULTIPLE_PROPERTIES';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';

export const SELECT_CASE = 'SELECT_CASE';

export const EXECUTION_STAMP_PAYMENT_BREAKDOWN_SUCCESS = 'EXECUTION_STAMP_PAYMENT_BREAKDOWN_SUCCESS';

export const FETCH_CASES_REQUEST_EXECUTION_STAMP_SUCCESS = 'FETCH_CASES_REQUEST_EXECUTION_STAMP_SUCCESS';

export const EXECUTION_STAMP_HANDLE_SEARCH_FEILD = 'EXECUTION_STAMP_HANDLE_SEARCH_FEILD';

export const FETCH_PROPERTY_REQUEST_EXECUTION_STAMP_SUCCESS = 'FETCH_PROPERTY_REQUEST_EXECUTION_STAMP_SUCCESS';
